import clsx from 'clsx';
import parentStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ArticleAside = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("aside", {
    className: clsx(parentStyles.article__aside, styles.container),
    children: children
  });
};

export default ArticleAside;